import React from 'react'
import { Icon } from '@chakra-ui/react'
import { IconType } from 'react-icons'

interface IconWrapperProps {
  icon: IconType
  [key: string]: any
}

const IconWrapper = ({ icon, ...props }: IconWrapperProps) => 
  <Icon as={icon as any} {...props} />

export default IconWrapper
